import useIsMobile from '@/Hooks/useIsMobile';
import useThemeStore from '@/Theme/store';
import { cn } from '@/utils/styles';
import { Tooltip } from '@mui/material';

const ActionButton = ({
  icon: Icon,
  text,
  onClick,
  active = false,
  tooltip,
  className = '',
  endContent: EndContent,
  tooltipRenderHtml = false,
}) => {
  const isMobile = useIsMobile();
  const { theme } = useThemeStore();
  return (
    <Tooltip
      arrow
      title={
        tooltipRenderHtml ? (
          <div dangerouslySetInnerHTML={{ __html: tooltip }} />
        ) : (
          tooltip
        )
      }
      placement="top"
    >
      <button
        onClick={onClick}
        className={cn(
          'flex w-fit capitalize items-center gap-1 px-2 py-1 text-sm font-medium rounded-xl transition-all duration-200 ease-in-out ',
          {
            'dark:bg-[#5C5A5E] dark:text-[#D4D5E6] dark:hover:bg-[#51526C] dark:hover:text-[#ADB1FF]':
              theme === 'dark',
            'bg-ghost-white text-[#51526C] hover:bg-lavender':
              theme === 'light',
            'dark:bg-[#51526C] dark:text-[#ADB1FF]': active && theme === 'dark',
            'bg-lavender text-violet-blue': active && theme === 'light',
          },
          className
        )}
      >
        {Icon && <Icon className="size-4" />}

        {!isMobile && <p className="max-w-[120px] truncate">{text}</p>}
        {EndContent && EndContent}
      </button>
    </Tooltip>
  );
};

export default ActionButton;
